module.exports = __webpack_public_path__ + "img/20200514_154849.2cf6a229.jpg";